import React from "react";
import "~/css/NestedAccordion.css";
import NestedAccordionItem from "./NestedAccordionItem";

/** 入れ子専用アコーディオン: Accordion へ影響を与えず個別拡張 */
export interface NestedAccordionProps {
  items: {
    title: string | React.JSX.Element;
    content: React.ReactNode;
    dynamicHeight?: boolean;
    summaryClassName?: string; // カスタムクラス
    defaultOpen?: boolean; // 初期展開
  }[];
  groupClassName?: string; // ルートラッパー
}

/**
 * 入れ子専用アコーディオン
 */
const NestedAccordion: React.FC<NestedAccordionProps> = ({
  items,
  groupClassName = "nested-accordion",
}) => {
  return (
    <div className={groupClassName}>
      {items.map((item, idx) => (
        <NestedAccordionItem
          key={idx}
          title={item.title}
          dynamicHeight={item.dynamicHeight}
          summaryClassName={item.summaryClassName}
          defaultOpen={item.defaultOpen}
        >
          {item.content}
        </NestedAccordionItem>
      ))}
    </div>
  );
};

export default NestedAccordion;
